import '../../pages/Auth/Login.css'

/**
 * El marco de las páginas sin sesión: registro, verificación, recuperar contraseña, legales.
 *
 * Reusa el sistema visual del login --panel de marca a la izquierda, tarjeta a la derecha, y en
 * el celular el panel arriba-- para que quien llega por el QR reconozca el producto desde la
 * primera pantalla. `ancho` agranda la tarjeta para los textos legales.
 */
export default function PaginaPublica({ titulo, subtitulo, encabezado, ancho, children }) {
  return (
    <div className="login-page">
      <aside className="login-panel">
        <div className="login-panel__veil" />
        <div className="login-panel__copy">
          <p className="login-panel__brand">Arithmos 360°</p>
          <h1 className="login-panel__title">{titulo}</h1>
          {subtitulo && <p className="login-panel__subtitle">{subtitulo}</p>}
        </div>
      </aside>

      <main className="login-form-wrap">
        <div className="login-form-card" style={ancho ? { maxWidth: ancho } : undefined}>
          <div className="login-form-header">
            <img
              src="/logo.png"
              alt="Arithmos"
              className="login-form-logo"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
            <h2>{encabezado}</h2>
          </div>
          {children}
        </div>
      </main>
    </div>
  )
}
